import { Keys } from '../shared/keys';
import { hasFocus } from '../utils/has-focus';

/**
 * @name isKeyboardClickOnFocusedElement
 *
 * @description Returns true if the given element has focus and either the space or enter key was pressed
 *
 * @example
 * import { isKeyboardClickOnFocusedElement } from '@workbench/core';
 *
 * isKeyboardClickOnFocusedElement(myElementReference, event); // true
 */

export function isKeyboardClickOnFocusedElement(element: HTMLElement, keyboardEvent: KeyboardEvent): boolean {
  return hasFocus(element) && (keyboardEvent.key === Keys.SPACE || keyboardEvent.key === Keys.ENTER);
}
